import { Button } from "@/components/ui/button";
import type { ContentType } from "@/types/ab-tests";

interface CreateTestFullPageFooterProps {
  step: 1 | 2;
  selectedFields: ContentType[];
  isSaving: boolean;
  isVariantBLoading?: boolean;
  isEditing?: boolean;
  onCancel: () => void;
  onContinue: () => void;
  onSaveTest: () => void;
  onCreateTest: () => void;
}

export function CreateTestFullPageFooter({
  step,
  selectedFields,
  isSaving,
  isVariantBLoading = false,
  isEditing = false,
  onCancel,
  onContinue,
  onSaveTest,
  onCreateTest,
}: CreateTestFullPageFooterProps) {
  const variantBLoadingTitle = isVariantBLoading ? "Variant B is being generated — please wait" : undefined;
  return (
    <div className="sticky bottom-0 border-t border-border bg-card px-6 py-3">
      <div className="flex items-center justify-end gap-2">
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        {isEditing ? (
          <Button onClick={onCreateTest} disabled={isSaving || isVariantBLoading} title={variantBLoadingTitle}>
            {isSaving ? "Saving\u2026" : "Save"}
          </Button>
        ) : (
          <>
            <Button variant="outline" onClick={onSaveTest} disabled={isSaving || isVariantBLoading} title={variantBLoadingTitle}>
              Save Test
            </Button>
            {step === 1 ? (
              <Button onClick={onContinue} disabled={selectedFields.length === 0}>
                Continue
              </Button>
            ) : (
              <Button onClick={onCreateTest} disabled={isSaving || isVariantBLoading} title={variantBLoadingTitle}>
                {isSaving ? "Saving\u2026" : "Create Test"}
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
